module.exports = __webpack_public_path__ + "img/20191217162459230.2d050406.jpg";